<template>
	<div>
		<span v-if="readonly" class="font-italic">
			{{
				configuration.positionNr === null ? $t('cartPosition.terms.noPositionNr') : configuration.positionNr
			}}
		</span>
		<v-menu v-else v-model="menuOpen" :disabled="readonly" :close-on-content-click="false"
		        max-width="30rem" bottom offset-y left>
			<template v-slot:activator="{on, attrs}">
				<div v-on="on" v-bind="attrs" class="d-flex flex-row align-center text-wrap">
					<span class="font-italic">
						{{
							configuration.positionNr === null ? $t('cartPosition.terms.noPositionNr') : configuration.positionNr
						}}
					</span>
					<AsiBtn v-if="!readonly" :icon="icons.edit" :loading="loading" :disabled="disabled" x-small class="ml-2"/>
				</div>
			</template>

			<div class="grey lighten-3 pa-2 d-flex flex-row align-center">
				<AsiTextFieldSimple v-model="inputValue" :disabled="disabled" style="width: 25rem"
				                    :label="$t('cartPosition.positionNr')" :palceholder="$t('cartPosition.positionNr')"
				                    @keydown.enter.prevent="keydownEnter"
				                    :rules="positionNrRule"
				                    clearable/>
				<AsiBtn :icon="icons.save" :disabled="!hasChange" @click="performUpdate" class="ml-2 align-self-start"/>
			</div>
		</v-menu>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component, Emit, Prop, Watch} from "vue-property-decorator";
	import AsiTextFieldSimple from "@/components/common/AsiTextFieldSimple";
	import StringHelper from "@/helpers/StringHelper";
	import AsiBtn from "@/components/common/AsiBtn.vue";
	import Icon from "@/plugins/icons";
	import Snackbar from "@/helpers/Snackbar";
	import {IFrameAssemblyConfiguration} from "@/models/frame-assembly/FrameAssemblyModels";
	import {ValidationRule} from "@/declarations/ValidationRule";
	import FrameAssemblyRules from "@/models/frame-assembly/FrameAssemblyRules";

	@Component({
		components: {AsiBtn, AsiTextFieldSimple}
	})
	export default class CartFrameAssemblyPositionNrInput extends Vue {

		@Prop({type: Object, required: true})
		public configuration!: IFrameAssemblyConfiguration;

		@Prop({type: String, required: true})
		public configurationGroupId!: string;

		@Prop({type: String, required: true})
		public positionId!: string;

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		@Prop({type: Boolean, default: false})
		public disabled!: boolean;

		private icons = Icon;
		private menuOpen: boolean = false;
		private valueInternal: string | null = null;
		private loading: boolean = false;

		private get hasChange(): boolean {
			return this.configuration.positionNr !== this.valueInternal && this.validateInput(this.valueInternal);
		}

		private get inputValue(): string | null {
			return this.valueInternal;
		}

		private set inputValue(value: string | null) {
			this.valueInternal = value === null || StringHelper.isEmpty(value) ? null : value.trim();
		}

		private get positionNrRule(): ValidationRule[] {
			return FrameAssemblyRules.positionNrRules;
		}

		private validateInput(value: string | null) {
			return this.positionNrRule.every(rule => rule(value) === true);
		}


		@Watch('configuration.positionNr', {immediate: true})
		private onConfigurationPositionNrChanged(value: string): void {
			this.valueInternal = value;
		}

		@Watch('menuOpen')
		private onMenuOpenChanged(value: boolean): void {
			if (!value) {
				this.valueInternal = this.configuration.positionNr;
			}
		}

		@Emit('change')
		public change(positionNr: string | null): string | null {
			return positionNr;
		}

		private keydownEnter(): void {
			if (this.hasChange) this.performUpdate();
		}

		private performUpdate(): void {
			if (!this.hasChange) return;

			this.loading = true;
			this.$store.dispatch('cart/updateFrameAssemblyConfigurationPositionNr', {
				positionId: this.positionId,
				configurationGroupId: this.configurationGroupId,
				configurationId: this.configuration.id,
				positionNr: this.valueInternal,
			})
				.then(() => {
					this.change(this.valueInternal);
					this.menuOpen = false;
				})
				.catch(() => Snackbar.updateError())
				.finally(() => this.loading = false);
		}

	}
</script>

<style lang="scss" scoped>

</style>
